import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Link, useParams } from "react-router-dom";
import api from "../Api";
import Popup from "../components/PopUP";

export default function UpdateAircraft() {
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [manufacturers, setManufacturer] = useState({});

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedManufacturerId, setSelectedManufacturerId] = useState("");
  const [selectedManufacturerName, setSelectedManufacturerName] = useState("");
  const [originalMfrName, setOriginalMfrName] = useState(""); // NEW: store original name from API
  const [showDropdown, setShowDropdown] = useState(false);
  const [images, setImages] = useState([
    { url: "", cc: "", is_default: false, source: "" },
  ]);
  const [popupType, setPopupType] = useState("info");

  const [formData, setFormData] = useState({
    ICAO_Type_Code: "",
    Aircraft_Model: "",
    Aircraft_Role: "",
    Aircraft_Type: "",
    Wake_Turbulence_Category: "",
    Civilian_Military_or_Dual_Use: "",
    Country_of_Origin: "",
    Date_of_Maiden_Flight: "",
    Year_of_Introduction: "",
    Production_Status: "",
    Avionics_System: "",
    Number_of_Crew: "",
    Number_of_Passengers_Typical: "",
    Number_of_Passengers_Maximum: "",
    Number_of_Engines: "",
    Engine_Manufacturer: "",
    Engine_Model: "",
    Engine_Type: "",
    Thrust_Per_Engine_kN_or_kW: "",
    Physical_Engine_Code: "",
    APU_Type: "",
    Fuel_Type: "",
    Fuel_Additives: "",
    Capacity_L_or_kg: "",
    Fuel_Burn_Cruise_kg_per_hr: "",
    Wingspan_m: "",
    Wingspan_ft: "",
    Length_m: "",
    Length_ft: "",
    Height_m: "",
    Height_ft: "",
    Wing_Area_m2: "",
    Cabin_Width_m: "",
    Door_Height_m: "",
    Wingtip_Configuration: "",
    Operating_Empty_Weight_kg: "",
    Maximum_Zero_Fuel_Weight_kg: "",
    Maximum_Takeoff_Weight_kg: "",
    Maximum_Payload_kg: "",
    Maximum_Landing_Weight_kg: "",
    Baggage_or_Cargo_Volume_Minimum_m3: "",
    Baggage_or_Cargo_Volume_Maximum_m3: "",
    Takeoff_Speed_kts: "",
    Takeoff_Distance_m: "",
    Initial_Climb_Rate_fpm: "",
    Average_Rate_of_Climb_fpm: "",
    Maximum_Rate_of_Climb_fpm: "",
    Service_Ceiling_ft: "",
    Max_Certified_Altitude_ft: "",
    Cruise_Speed_kt: "",
    Cruise_Mach: "",
    Maximum_Cruise_Speed_kts_or_Mach: "",
    VMO_kts: "",
    MMO_Mach: "",
    Normal_Range_NM: "",
    Normal_Range_km: "",
    Ferry_Range_NM: "",
    Initial_Rate_of_Descent_fpm: "",
    Average_Rate_of_Descent_fpm: "",
    Minimum_Clean_Speed_kts: "",
    Approach_Speed_kts: "",
    Approach_Category: "",
    Landing_Speed_kts: "",
    Landing_Distance_m: "",
    Runway_Length_Required_m: "",
    Stall_Speed_kts: "",
    Runway_Slope_Limit_percent: "",
    Max_Crosswind_Normal_Law_kts: "",
    Max_Crosswind_Degraded_Law_kts: "",
    Max_Tailwind_Landing_kts: "",
    Max_Tailwind_Takeoff_kts: "",
    Field_Elevation_Limit_ft: "",
    Max_Runway_Altitude_ft: "",
    Autoland_Capability_Supported_Categories: "",
    Certified_Autoland_Level: "",
    Landing_Gear_Type: "",
    Number_of_Wheels: "",
    Tyre_Size_inches: "",
    Tyre_Pressure_bar_psi: "",
    Certification_Basis: "",
    EASA_TCDS_Number: "",
    FAA_TCDS_Number: "",
    Special_Conditions: "",
    Noise_Compliance: "",
    Emissions_Category: "",
  });

  // Fetch manufacturers on mount
  useEffect(() => {
    const fetchManufacturers = async () => {
      try {
        const response = await api.get("/airplane-service/manufacturer/");
        setManufacturer(response.data);
      } catch (error) {
        console.error("API Error:", error.message);
      }
    };

    fetchManufacturers();
  }, []);

  // Fetch aircraft details
  useEffect(() => {
    const fetchAircraftDetails = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/airplane-service/aircraft/details/${id}`);
        console.log("Fetched Aircraft Details:", response.data);

        const data = response.data.results;

        // Map nested API response to formData
        setFormData({
          ICAO_Type_Code: data.IdentificationClassification?.ICAO_Type_Code || "",
          Aircraft_Model: data.IdentificationClassification?.Aircraft_Model || "",
          Aircraft_Role: data.IdentificationClassification?.Aircraft_Role || "",
          Aircraft_Type: data.IdentificationClassification?.Aircraft_Type || "",
          Wake_Turbulence_Category: data.IdentificationClassification?.Wake_Turbulence_Category || "",
          Civilian_Military_or_Dual_Use: data.IdentificationClassification?.Civilian_Military_or_Dual_Use || "",
          Country_of_Origin: data.IdentificationClassification?.Country_of_Origin || "",
          Date_of_Maiden_Flight: data.IdentificationClassification?.Date_of_Maiden_Flight || "",
          Year_of_Introduction: data.IdentificationClassification?.Year_of_Introduction || "",
          Production_Status: data.IdentificationClassification?.Production_Status || "",
          Avionics_System: data.IdentificationClassification?.Avionics_System || "",
          Number_of_Crew: data.IdentificationClassification?.Number_of_Crew || "",
          Number_of_Passengers_Typical: data.IdentificationClassification?.Number_of_Passengers?.Typical || "",
          Number_of_Passengers_Maximum: data.IdentificationClassification?.Number_of_Passengers?.Maximum || "",
          Number_of_Engines: data.PowerplantPropulsion?.Number_of_Engines || "",
          Engine_Manufacturer: data.PowerplantPropulsion?.Engine?.Manufacturer || "",
          Engine_Model: data.PowerplantPropulsion?.Engine?.Model || "",
          Engine_Type: data.PowerplantPropulsion?.Engine?.Engine_Type || "",
          Thrust_Per_Engine_kN_or_kW: data.PowerplantPropulsion?.Engine?.Thrust_Per_Engine_kN_or_kW || "",
          Physical_Engine_Code: data.PowerplantPropulsion?.Engine?.Physical_Engine_Code || "",
          APU_Type: data.PowerplantPropulsion?.APU_Type || "",
          Fuel_Type: data.PowerplantPropulsion?.Fuel?.Fuel_Type || "",
          Fuel_Additives: data.PowerplantPropulsion?.Fuel?.Fuel_Additives || "",
          Capacity_L_or_kg: data.PowerplantPropulsion?.Fuel?.Capacity_L_or_kg || "",
          Fuel_Burn_Cruise_kg_per_hr: data.PowerplantPropulsion?.Fuel?.Fuel_Burn_Cruise_kg_per_hr || "",
          Wingspan_m: data.Dimensions?.Wingspan_m || "",
          Wingspan_ft: data.Dimensions?.Wingspan_ft || "",
          Length_m: data.Dimensions?.Length_m || "",
          Length_ft: data.Dimensions?.Length_ft || "",
          Height_m: data.Dimensions?.Height_m || "",
          Height_ft: data.Dimensions?.Height_ft || "",
          Wing_Area_m2: data.Dimensions?.Wing_Area_m2 || "",
          Cabin_Width_m: data.Dimensions?.Cabin_Width_m || "",
          Door_Height_m: data.Dimensions?.Door_Height_m || "",
          Wingtip_Configuration: data.Dimensions?.Wingtip_Configuration || "",
          Operating_Empty_Weight_kg: data.Weights?.Operating_Empty_Weight_kg || "",
          Maximum_Zero_Fuel_Weight_kg: data.Weights?.Maximum_Zero_Fuel_Weight_kg || "",
          Maximum_Takeoff_Weight_kg: data.Weights?.Maximum_Takeoff_Weight_kg || "",
          Maximum_Payload_kg: data.Weights?.Maximum_Payload_kg || "",
          Maximum_Landing_Weight_kg: data.Weights?.Maximum_Landing_Weight_kg || "",
          Baggage_or_Cargo_Volume_Minimum_m3: data.Weights?.Baggage_or_Cargo_Volume?.Minimum_m3 || "",
          Baggage_or_Cargo_Volume_Maximum_m3: data.Weights?.Baggage_or_Cargo_Volume?.Maximum_m3 || "",
          Takeoff_Speed_kts: data.Performance?.Takeoff_Speed_kts || "",
          Takeoff_Distance_m: data.Performance?.Takeoff_Distance_m || "",
          Initial_Climb_Rate_fpm: data.Performance?.Initial_Climb_Rate_fpm || "",
          Average_Rate_of_Climb_fpm: data.Performance?.Average_Rate_of_Climb_fpm || "",
          Maximum_Rate_of_Climb_fpm: data.Performance?.Maximum_Rate_of_Climb_fpm || "",
          Service_Ceiling_ft: data.Performance?.Service_Ceiling_ft || "",
          Max_Certified_Altitude_ft: data.Performance?.Max_Certified_Altitude_ft || "",
          Cruise_Speed_kt: data.Performance?.Cruise_Speed_kt || "",
          Cruise_Mach: data.Performance?.Cruise_Mach || "",
          Maximum_Cruise_Speed_kts_or_Mach: data.Performance?.Maximum_Cruise_Speed_kts_or_Mach || "",
          VMO_kts: data.Performance?.VMO_kts || "",
          MMO_Mach: data.Performance?.MMO_Mach || "",
          Normal_Range_NM: data.Performance?.Range?.Normal_Range_NM || "",
          Normal_Range_km: data.Performance?.Range?.Normal_Range_km || "",
          Ferry_Range_NM: data.Performance?.Range?.Ferry_Range_NM || "",
          Initial_Rate_of_Descent_fpm: data.Performance?.Initial_Rate_of_Descent_fpm || "",
          Average_Rate_of_Descent_fpm: data.Performance?.Average_Rate_of_Descent_fpm || "",
          Minimum_Clean_Speed_kts: data.Performance?.Minimum_Clean_Speed_kts || "",
          Approach_Speed_kts: data.Performance?.Approach_Speed_kts || "",
          Approach_Category: data.Performance?.Approach_Category || "",
          Landing_Speed_kts: data.Performance?.Landing_Speed_kts || "",
          Landing_Distance_m: data.Performance?.Landing_Distance_m || "",
          Runway_Length_Required_m: data.Performance?.Runway_Length_Required_m || "",
          Stall_Speed_kts: data.Performance?.Stall_Speed_kts || "",
          Runway_Slope_Limit_percent: data.OperationalLimitations?.Runway_Slope_Limit_percent || "",
          Max_Crosswind_Normal_Law_kts: data.OperationalLimitations?.Max_Crosswind_Normal_Law_kts || "",
          Max_Crosswind_Degraded_Law_kts: data.OperationalLimitations?.Max_Crosswind_Degraded_Law_kts || "",
          Max_Tailwind_Landing_kts: data.OperationalLimitations?.Max_Tailwind_Landing_kts || "",
          Max_Tailwind_Takeoff_kts: data.OperationalLimitations?.Max_Tailwind_Takeoff_kts || "",
          Field_Elevation_Limit_ft: data.OperationalLimitations?.Field_Elevation_Limit_ft || "",
          Max_Runway_Altitude_ft: data.OperationalLimitations?.Max_Runway_Altitude_ft || "",
          Autoland_Capability_Supported_Categories: data.OperationalLimitations?.Autoland_Capability?.Supported_Categories || "",
          Certified_Autoland_Level: data.OperationalLimitations?.Autoland_Capability?.Certified_Autoland_Level || "",
          Landing_Gear_Type: data.LandingGear?.Type || "",
          Number_of_Wheels: data.LandingGear?.Number_of_Wheels || "",
          Tyre_Size_inches: data.LandingGear?.Tyre_Size_inches || "",
          Tyre_Pressure_bar_psi: data.LandingGear?.Tyre_Pressure_bar_psi || "",
          Certification_Basis: data.CertificationEnvironmental?.Certification_Basis || "",
          EASA_TCDS_Number: data.CertificationEnvironmental?.EASA_TCDS_Number || "",
          FAA_TCDS_Number: data.CertificationEnvironmental?.FAA_TCDS_Number || "",
          Special_Conditions: data.CertificationEnvironmental?.Special_Conditions || "",
          Noise_Compliance: data.CertificationEnvironmental?.Noise_Compliance || "",
          Emissions_Category: data.CertificationEnvironmental?.Emissions_Category || "",
        });

        // ✅ Store the manufacturer name from API (not the ID yet)
        if (data.IdentificationClassification?.Manufacturer) {
          const manufacturerName = data.IdentificationClassification.Manufacturer;
          setOriginalMfrName(manufacturerName);        // store for later matching
          setSelectedManufacturerName(manufacturerName);
          setSearchQuery(manufacturerName);
          // Do NOT set selectedManufacturerId here; wait for manufacturers list
        }

        // Set images
        if (data.Images && data.Images.length > 0) {
          setImages(data.Images);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching aircraft details:", error);
        setPopupMessage("Error loading aircraft details");
        setLoading(false);
      }
    };

    if (id) {
      fetchAircraftDetails();
    }
  }, [id]);

  // ✅ NEW: After both lists are loaded, match the original manufacturer name to its ID
  useEffect(() => {
    if (
      manufacturers.results &&
      manufacturers.results.length > 0 &&
      originalMfrName &&
      !selectedManufacturerId
    ) {
      const matched = manufacturers.results.find(
        (mfr) => mfr.company_name.toLowerCase() === originalMfrName.toLowerCase()
      );
      if (matched) {
        setSelectedManufacturerId(matched.id);
      }
    }
  }, [manufacturers, originalMfrName, selectedManufacturerId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleChange = (index, field, value) => {
    const newImages = [...images];

    if (field === "is_default" && value === true) {
      newImages.forEach((image, i) => {
        image.is_default = i === index;
      });
    } else {
      newImages[index][field] = value;
    }

    setImages(newImages);
  };

  const addImage = () => {
    setImages([...images, { url: "", cc: "", is_default: false, source: "" }]);
  };

  const removeImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);
  };

  const filteredManufacturers = manufacturers.results
    ? manufacturers.results.filter((mfr) =>
      mfr.company_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  const handleManufacturerSelect = (id, name) => {
    setSelectedManufacturerId(id);
    setSelectedManufacturerName(name);
    setSearchQuery(name);
    setShowDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Optional: ensure manufacturer is selected
    if (!selectedManufacturerId) {
      setPopupMessage("Please select a manufacturer.");
      setPopupType("danger");
      return;
    }

    const payload = {
      Identification_Classification: {
        ICAO_Type_Code: formData.ICAO_Type_Code,
        Manufacturer: selectedManufacturerId,
        manufacturer_id: selectedManufacturerId,
        Aircraft_Manufacturer: selectedManufacturerName,
        Aircraft_Model: formData.Aircraft_Model,
        Aircraft_Role: formData.Aircraft_Role,
        Aircraft_Type: formData.Aircraft_Type,
        Wake_Turbulence_Category: formData.Wake_Turbulence_Category,
        Civilian_Military_or_Dual_Use: formData.Civilian_Military_or_Dual_Use,
        Country_of_Origin: formData.Country_of_Origin,
        Date_of_Maiden_Flight: formData.Date_of_Maiden_Flight,
        Year_of_Introduction: formData.Year_of_Introduction,
        Production_Status: formData.Production_Status,
        Avionics_System: formData.Avionics_System,
        Number_of_Crew: formData.Number_of_Crew,
        Number_of_Passengers: {
          Typical: formData.Number_of_Passengers_Typical,
          Maximum: formData.Number_of_Passengers_Maximum,
        },
      },
      Powerplant_Propulsion: {
        Number_of_Engines: formData.Number_of_Engines,
        Engine: {
          Manufacturer: formData.Engine_Manufacturer,
          Model: formData.Engine_Model,
          Engine_Type: formData.Engine_Type,
          Thrust_Per_Engine_kN_or_kW: formData.Thrust_Per_Engine_kN_or_kW,
          Physical_Engine_Code: formData.Physical_Engine_Code,
        },
        APU_Type: formData.APU_Type,
        Fuel: {
          Fuel_Type: formData.Fuel_Type,
          Fuel_Additives: formData.Fuel_Additives,
          Capacity_L_or_kg: formData.Capacity_L_or_kg,
          Fuel_Burn_Cruise_kg_per_hr: formData.Fuel_Burn_Cruise_kg_per_hr,
        },
      },
      Dimensions: {
        Wingspan_m: formData.Wingspan_m,
        Wingspan_ft: formData.Wingspan_ft,
        Length_m: formData.Length_m,
        Length_ft: formData.Length_ft,
        Height_m: formData.Height_m,
        Height_ft: formData.Height_ft,
        Wing_Area_m2: formData.Wing_Area_m2,
        Cabin_Width_m: formData.Cabin_Width_m,
        Door_Height_m: formData.Door_Height_m,
        Wingtip_Configuration: formData.Wingtip_Configuration,
      },
      Weights: {
        Operating_Empty_Weight_kg: formData.Operating_Empty_Weight_kg,
        Maximum_Zero_Fuel_Weight_kg: formData.Maximum_Zero_Fuel_Weight_kg,
        Maximum_Takeoff_Weight_kg: formData.Maximum_Takeoff_Weight_kg,
        Maximum_Payload_kg: formData.Maximum_Payload_kg,
        Maximum_Landing_Weight_kg: formData.Maximum_Landing_Weight_kg,
        Baggage_or_Cargo_Volume: {
          Minimum_m3: formData.Baggage_or_Cargo_Volume_Minimum_m3,
          Maximum_m3: formData.Baggage_or_Cargo_Volume_Maximum_m3,
        },
      },
      Performance: {
        Takeoff_Speed_kts: formData.Takeoff_Speed_kts,
        Takeoff_Distance_m: formData.Takeoff_Distance_m,
        Initial_Climb_Rate_fpm: formData.Initial_Climb_Rate_fpm,
        Average_Rate_of_Climb_fpm: formData.Average_Rate_of_Climb_fpm,
        Maximum_Rate_of_Climb_fpm: formData.Maximum_Rate_of_Climb_fpm,
        Service_Ceiling_ft: formData.Service_Ceiling_ft,
        Max_Certified_Altitude_ft: formData.Max_Certified_Altitude_ft,
        Cruise_Speed_kt: formData.Cruise_Speed_kt,
        Cruise_Mach: formData.Cruise_Mach,
        Maximum_Cruise_Speed_kts_or_Mach:
          formData.Maximum_Cruise_Speed_kts_or_Mach,
        VMO_kts: formData.VMO_kts,
        MMO_Mach: formData.MMO_Mach,
        Range: {
          Normal_Range_NM: formData.Normal_Range_NM,
          Normal_Range_km: formData.Normal_Range_km,
          Ferry_Range_NM: formData.Ferry_Range_NM,
        },
        Initial_Rate_of_Descent_fpm: formData.Initial_Rate_of_Descent_fpm,
        Average_Rate_of_Descent_fpm: formData.Average_Rate_of_Descent_fpm,
        Minimum_Clean_Speed_kts: formData.Minimum_Clean_Speed_kts,
        Approach_Speed_kts: formData.Approach_Speed_kts,
        Approach_Category: formData.Approach_Category,
        Landing_Speed_kts: formData.Landing_Speed_kts,
        Landing_Distance_m: formData.Landing_Distance_m,
        Runway_Length_Required_m: formData.Runway_Length_Required_m,
        Stall_Speed_kts: formData.Stall_Speed_kts,
      },
      Operational_Limitations: {
        Runway_Slope_Limit_percent: formData.Runway_Slope_Limit_percent,
        Max_Crosswind_Normal_Law_kts: formData.Max_Crosswind_Normal_Law_kts,
        Max_Crosswind_Degraded_Law_kts: formData.Max_Crosswind_Degraded_Law_kts,
        Max_Tailwind_Landing_kts: formData.Max_Tailwind_Landing_kts,
        Max_Tailwind_Takeoff_kts: formData.Max_Tailwind_Takeoff_kts,
        Field_Elevation_Limit_ft: formData.Field_Elevation_Limit_ft,
        Max_Runway_Altitude_ft: formData.Max_Runway_Altitude_ft,
        Autoland_Capability: {
          Supported_Categories: formData.Autoland_Capability_Supported_Categories,
          Certified_Autoland_Level: formData.Certified_Autoland_Level,
        },
      },
      Landing_Gear_Configuration: {
        Type: formData.Landing_Gear_Type,
        Number_of_Wheels: formData.Number_of_Wheels,
        Tyre_Size_inches: formData.Tyre_Size_inches,
        Tyre_Pressure_bar_psi: formData.Tyre_Pressure_bar_psi,
      },
      Certification_Environmental: {
        Certification_Basis: formData.Certification_Basis,
        EASA_TCDS_Number: formData.EASA_TCDS_Number,
        FAA_TCDS_Number: formData.FAA_TCDS_Number,
        Special_Conditions: formData.Special_Conditions,
        Noise_Compliance: formData.Noise_Compliance,
        Emissions_Category: formData.Emissions_Category,
      },
      images: images,
    };

    try {
      const response = await api.patch(`/airplane-service/aircraft/${id}`, payload);
      setPopupType("info");
      setPopupMessage(
        response.data.message || "Aircraft updated successfully"
      );
    } catch (error) {
      console.error("API Error:", error.message);
      setPopupType("danger");
      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.detail ||
          error.response.data?.error ||
          `Error (${error.response.status}): ${error.response.statusText}`;
        setPopupMessage(`Update failed: ${errorMessage}`);
      } else if (error.request) {
        setPopupMessage("Update failed: No response from server");
      } else {
        setPopupMessage("Update failed: Network error");
      }
    }
  };
  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="main-wrapper">
          <Header />
          <div className="content-wrapper">
            <div className="container mt-5">
              <p>Loading aircraft details...</p>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Popup
        message={popupMessage}
        onClose={() => setPopupMessage("")}
        type={popupType}
      />
      <Sidebar />
      <div className="main-wrapper">
        <Header />

        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <nav className="breadcrumb_nav">
                          <ul className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/aircraft">Aircraft Management</Link>
                            </li>
                            <li className="breadcrumb-item text-capitalize">
                              Update Aircraft
                            </li>
                          </ul>
                        </nav>
                        <h1>Aircraft Management</h1>
                      </div>
                      <div className="d-flex flex-end">
                        <Link to="/aircraft" className="secondary_btn">
                          View All Aircraft
                        </Link>
                      </div>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="common-outer-card mt-4">
                      <div className="common_sub_heading_wrapper">
                        <h2>Update Aircraft</h2>
                      </div>

                      <div className="common_content_blk">
                        <div className="row g-4">
                          {/* Identification & Classification Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Identification & Classification</h3>
                            </div>
                          </div>

                          {/* Images Display */}
                          {/* {images && images.length > 0 && (
                            <div className="col-12">
                              <div style={{
                                backgroundColor: "#f8f9fa",
                                padding: "20px",
                                borderRadius: "8px",
                                marginBottom: "20px"
                              }}>
                                <h5 style={{ marginBottom: "15px", fontWeight: "600" }}>Aircraft Images</h5>
                                <div className="row g-3">
                                  {images.map((image, index) => (
                                    <div key={index} className="col-12 col-sm-6 col-md-4">
                                      <div style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "6px",
                                        overflow: "hidden",
                                        backgroundColor: "#fff",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                      }}>
                                        {image.url && (
                                          <img
                                            src={image.url}
                                            alt={`Aircraft ${index + 1}`}
                                            style={{
                                              width: "100%",
                                              height: "200px",
                                              objectFit: "cover",
                                              display: "block"
                                            }}
                                          />
                                        )}
                                        <div style={{ padding: "10px" }}>
                                          {image.is_default && (
                                            <span style={{
                                              display: "inline-block",
                                              backgroundColor: "#28a745",
                                              color: "#fff",
                                              padding: "4px 8px",
                                              borderRadius: "4px",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "8px"
                                            }}>
                                              Default
                                            </span>
                                          )}
                                          {image.cc && (
                                            <p style={{ fontSize: "12px", marginBottom: "5px", color: "#666" }}>
                                              <strong>Credit:</strong> {image.cc}
                                            </p>
                                          )}
                                          {image.source && (
                                            <p style={{ fontSize: "12px", marginBottom: "0", color: "#666" }}>
                                              <strong>Source:</strong> <a href={image.source} target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc" }}>View</a>
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )} */}



                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>ICAO Type Code</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter ICAO Type Code"
                                  name="ICAO_Type_Code"
                                  value={formData.ICAO_Type_Code}
                                  onChange={handleInputChange}
                                />
                                <span className="error">
                                  {errors.ICAO_Type_Code}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Aircraft Manufacturer</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search Manufacturer..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  onFocus={() => setShowDropdown(true)}
                                  onBlur={() =>
                                    setTimeout(
                                      () => setShowDropdown(false),
                                      200
                                    )
                                  }
                                />
                                {showDropdown && (
                                  <ul
                                    className="dropdown-menu show"
                                    style={{
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {filteredManufacturers.map((mfr) => (
                                      <li key={mfr.id}>
                                        <button
                                          type="button"
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleManufacturerSelect(
                                              mfr.id,
                                              mfr.company_name
                                            )
                                          }
                                        >
                                          {mfr.company_name}
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Aircraft Model</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Aircraft Model"
                                  name="Aircraft_Model"
                                  value={formData.Aircraft_Model}
                                  onChange={handleInputChange}
                                />
                                <span className="error">
                                  {errors.Aircraft_Model}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Aircraft Role</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Aircraft Role"
                                  name="Aircraft_Role"
                                  value={formData.Aircraft_Role}
                                  onChange={handleInputChange}
                                />
                                <span className="error">
                                  {errors.Aircraft_Role}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Aircraft Type</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Aircraft Type"
                                  name="Aircraft_Type"
                                  value={formData.Aircraft_Type}
                                  onChange={handleInputChange}
                                />
                                <span className="error">
                                  {errors.Aircraft_Type}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Wake Turbulence Category</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Wake Turbulence Category"
                                  name="Wake_Turbulence_Category"
                                  value={formData.Wake_Turbulence_Category}
                                  onChange={handleInputChange}
                                />
                                <span className="error">
                                  {errors.Wake_Turbulence_Category}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Civilian/Military/Dual Use</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter classification"
                                  name="Civilian_Military_or_Dual_Use"
                                  value={formData.Civilian_Military_or_Dual_Use}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Country of Origin</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter country"
                                  name="Country_of_Origin"
                                  value={formData.Country_of_Origin}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Date of Maiden Flight</label>
                              <div className="input_field">
                                <input
                                  type="date"
                                  className="form-control"
                                  name="Date_of_Maiden_Flight"
                                  value={formData.Date_of_Maiden_Flight}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Year of Introduction</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter year"
                                  name="Year_of_Introduction"
                                  value={formData.Year_of_Introduction}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Production Status</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter production status"
                                  name="Production_Status"
                                  value={formData.Production_Status}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Avionics System</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter avionics system"
                                  name="Avionics_System"
                                  value={formData.Avionics_System}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>


                          {/* Images Edit Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Update Images</h3>
                            </div>
                          </div>

                          {images.map((image, index) => (
                            <div key={index} className="col-12">
                              <div style={{
                                border: "1px solid #dee2e6",
                                padding: "15px",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                marginBottom: "15px"
                              }}>
                                <div className="row g-3">
                                  <div className="col-12 col-md-6">
                                    <div className="form_field">
                                      <label>Image URL</label>
                                      <div className="input_field">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter image URL"
                                          value={image.url}
                                          onChange={(e) => handleChange(index, "url", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="form_field">
                                      <label>Credit/Copyright</label>
                                      <div className="input_field">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="e.g., Dmitry Karpezo"
                                          value={image.cc}
                                          onChange={(e) => handleChange(index, "cc", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-3">
                                    <div className="form_field">
                                      <label>Set as Default</label>
                                      <div className="input_field">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={image.is_default}
                                          onChange={(e) => handleChange(index, "is_default", e.target.checked)}
                                          style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12">
                                    <div className="form_field">
                                      <label>Source URL</label>
                                      <div className="input_field">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="https://example.com"
                                          value={image.source}
                                          onChange={(e) => handleChange(index, "source", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12">
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => removeImage(index)}
                                    >
                                      Remove Image
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                          <div className="col-12">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={addImage}
                            >
                              + Add New Image
                            </button>
                          </div>

                          {/* Personnel Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Personnel & Capacity</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Number of Crew</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter crew count"
                                  name="Number_of_Crew"
                                  value={formData.Number_of_Crew}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Passengers (Typical)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter typical passengers"
                                  name="Number_of_Passengers_Typical"
                                  value={formData.Number_of_Passengers_Typical}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Passengers (Maximum)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter maximum passengers"
                                  name="Number_of_Passengers_Maximum"
                                  value={formData.Number_of_Passengers_Maximum}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Engines Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Engines</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Number of Engines</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter number of engines"
                                  name="Number_of_Engines"
                                  value={formData.Number_of_Engines}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Engine Manufacturer</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter engine manufacturer"
                                  name="Engine_Manufacturer"
                                  value={formData.Engine_Manufacturer}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Engine Model</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter engine model"
                                  name="Engine_Model"
                                  value={formData.Engine_Model}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Engine Type</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter engine type"
                                  name="Engine_Type"
                                  value={formData.Engine_Type}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Thrust Per Engine (kN/kW)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter thrust"
                                  name="Thrust_Per_Engine_kN_or_kW"
                                  value={formData.Thrust_Per_Engine_kN_or_kW}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Physical Engine Code</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter engine code"
                                  name="Physical_Engine_Code"
                                  value={formData.Physical_Engine_Code}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* APU Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>APU & Fuel System</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>APU Type</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter APU type"
                                  name="APU_Type"
                                  value={formData.APU_Type}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Fuel Type</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter fuel type"
                                  name="Fuel_Type"
                                  value={formData.Fuel_Type}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Fuel Additives</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter fuel additives"
                                  name="Fuel_Additives"
                                  value={formData.Fuel_Additives}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Fuel Capacity (L/kg)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter capacity"
                                  name="Capacity_L_or_kg"
                                  value={formData.Capacity_L_or_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Fuel Burn Cruise (kg/hr)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter fuel burn"
                                  name="Fuel_Burn_Cruise_kg_per_hr"
                                  value={formData.Fuel_Burn_Cruise_kg_per_hr}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Dimensions Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Dimensions</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Wingspan (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter wingspan (m)"
                                  name="Wingspan_m"
                                  value={formData.Wingspan_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Wingspan (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter wingspan (ft)"
                                  name="Wingspan_ft"
                                  value={formData.Wingspan_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Length (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter length (m)"
                                  name="Length_m"
                                  value={formData.Length_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Length (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter length (ft)"
                                  name="Length_ft"
                                  value={formData.Length_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Height (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter height (m)"
                                  name="Height_m"
                                  value={formData.Height_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Height (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter height (ft)"
                                  name="Height_ft"
                                  value={formData.Height_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Wing Area (m²)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter wing area"
                                  name="Wing_Area_m2"
                                  value={formData.Wing_Area_m2}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Cabin Width (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter cabin width"
                                  name="Cabin_Width_m"
                                  value={formData.Cabin_Width_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Door Height (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter door height"
                                  name="Door_Height_m"
                                  value={formData.Door_Height_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Wingtip Configuration</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter configuration"
                                  name="Wingtip_Configuration"
                                  value={formData.Wingtip_Configuration}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Weights & Capacities Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Weights & Capacities</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Operating Empty Weight (kg)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter weight"
                                  name="Operating_Empty_Weight_kg"
                                  value={formData.Operating_Empty_Weight_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Zero Fuel Weight (kg)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter weight"
                                  name="Maximum_Zero_Fuel_Weight_kg"
                                  value={formData.Maximum_Zero_Fuel_Weight_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Takeoff Weight (kg)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter weight"
                                  name="Maximum_Takeoff_Weight_kg"
                                  value={formData.Maximum_Takeoff_Weight_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Payload (kg)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter payload"
                                  name="Maximum_Payload_kg"
                                  value={formData.Maximum_Payload_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Landing Weight (kg)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter weight"
                                  name="Maximum_Landing_Weight_kg"
                                  value={formData.Maximum_Landing_Weight_kg}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Cargo Volume Min (m³)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter volume"
                                  name="Baggage_or_Cargo_Volume_Minimum_m3"
                                  value={formData.Baggage_or_Cargo_Volume_Minimum_m3}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Cargo Volume Max (m³)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter volume"
                                  name="Baggage_or_Cargo_Volume_Maximum_m3"
                                  value={formData.Baggage_or_Cargo_Volume_Maximum_m3}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Performance Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Performance</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Takeoff Speed (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Takeoff_Speed_kts"
                                  value={formData.Takeoff_Speed_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Takeoff Distance (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter distance"
                                  name="Takeoff_Distance_m"
                                  value={formData.Takeoff_Distance_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Initial Climb Rate (fpm)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter rate"
                                  name="Initial_Climb_Rate_fpm"
                                  value={formData.Initial_Climb_Rate_fpm}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Average Climb Rate (fpm)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter rate"
                                  name="Average_Rate_of_Climb_fpm"
                                  value={formData.Average_Rate_of_Climb_fpm}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Climb Rate (fpm)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter rate"
                                  name="Maximum_Rate_of_Climb_fpm"
                                  value={formData.Maximum_Rate_of_Climb_fpm}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Service Ceiling (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter ceiling"
                                  name="Service_Ceiling_ft"
                                  value={formData.Service_Ceiling_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Certified Altitude (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter altitude"
                                  name="Max_Certified_Altitude_ft"
                                  value={formData.Max_Certified_Altitude_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Cruise Speed (kt)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Cruise_Speed_kt"
                                  value={formData.Cruise_Speed_kt}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Cruise Mach</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter mach"
                                  name="Cruise_Mach"
                                  value={formData.Cruise_Mach}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Max Cruise Speed (kts/Mach)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter speed/mach"
                                  name="Maximum_Cruise_Speed_kts_or_Mach"
                                  value={formData.Maximum_Cruise_Speed_kts_or_Mach}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>VMO (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter VMO"
                                  name="VMO_kts"
                                  value={formData.VMO_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>MMO (Mach)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter MMO"
                                  name="MMO_Mach"
                                  value={formData.MMO_Mach}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Normal Range (NM)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter range"
                                  name="Normal_Range_NM"
                                  value={formData.Normal_Range_NM}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Normal Range (km)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter range"
                                  name="Normal_Range_km"
                                  value={formData.Normal_Range_km}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Ferry Range (NM)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter range"
                                  name="Ferry_Range_NM"
                                  value={formData.Ferry_Range_NM}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Landing & Descent Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Landing & Descent</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Initial Descent Rate (fpm)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter rate"
                                  name="Initial_Rate_of_Descent_fpm"
                                  value={formData.Initial_Rate_of_Descent_fpm}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Average Descent Rate (fpm)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter rate"
                                  name="Average_Rate_of_Descent_fpm"
                                  value={formData.Average_Rate_of_Descent_fpm}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Min Clean Speed (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Minimum_Clean_Speed_kts"
                                  value={formData.Minimum_Clean_Speed_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Approach Speed (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Approach_Speed_kts"
                                  value={formData.Approach_Speed_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Approach Category</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter category"
                                  name="Approach_Category"
                                  value={formData.Approach_Category}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Landing Speed (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Landing_Speed_kts"
                                  value={formData.Landing_Speed_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Landing Distance (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter distance"
                                  name="Landing_Distance_m"
                                  value={formData.Landing_Distance_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Runway Length Required (m)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter length"
                                  name="Runway_Length_Required_m"
                                  value={formData.Runway_Length_Required_m}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-3">
                            <div className="form_field">
                              <label>Stall Speed (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter speed"
                                  name="Stall_Speed_kts"
                                  value={formData.Stall_Speed_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Runway & Wind Limits Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Runway & Wind Limits</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Runway Slope Limit (%)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter slope"
                                  name="Runway_Slope_Limit_percent"
                                  value={formData.Runway_Slope_Limit_percent}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Max Crosswind Normal Law (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter wind"
                                  name="Max_Crosswind_Normal_Law_kts"
                                  value={formData.Max_Crosswind_Normal_Law_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Max Crosswind Degraded Law (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter wind"
                                  name="Max_Crosswind_Degraded_Law_kts"
                                  value={formData.Max_Crosswind_Degraded_Law_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Max Tailwind Landing (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter tailwind"
                                  name="Max_Tailwind_Landing_kts"
                                  value={formData.Max_Tailwind_Landing_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Max Tailwind Takeoff (kts)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter tailwind"
                                  name="Max_Tailwind_Takeoff_kts"
                                  value={formData.Max_Tailwind_Takeoff_kts}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Field Elevation Limit (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter elevation"
                                  name="Field_Elevation_Limit_ft"
                                  value={formData.Field_Elevation_Limit_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Max Runway Altitude (ft)</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter altitude"
                                  name="Max_Runway_Altitude_ft"
                                  value={formData.Max_Runway_Altitude_ft}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Autoland Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Autoland Capability</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6">
                            <div className="form_field">
                              <label>Supported Categories</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter categories"
                                  name="Autoland_Capability_Supported_Categories"
                                  value={formData.Autoland_Capability_Supported_Categories}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-6">
                            <div className="form_field">
                              <label>Certified Autoland Level</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter level"
                                  name="Certified_Autoland_Level"
                                  value={formData.Certified_Autoland_Level}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Landing Gear & Tires Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Landing Gear & Tires</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Landing Gear Type</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter type"
                                  name="Landing_Gear_Type"
                                  value={formData.Landing_Gear_Type}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Number of Wheels</label>
                              <div className="input_field">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter number"
                                  name="Number_of_Wheels"
                                  value={formData.Number_of_Wheels}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Tyre Size (inches)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter size"
                                  name="Tyre_Size_inches"
                                  value={formData.Tyre_Size_inches}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Tyre Pressure (bar/psi)</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter pressure"
                                  name="Tyre_Pressure_bar_psi"
                                  value={formData.Tyre_Pressure_bar_psi}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Certification Section */}
                          <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                              <h3>Certification & Compliance</h3>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Certification Basis</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter basis"
                                  name="Certification_Basis"
                                  value={formData.Certification_Basis}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>EASA TCDS Number</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter number"
                                  name="EASA_TCDS_Number"
                                  value={formData.EASA_TCDS_Number}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>FAA TCDS Number</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter number"
                                  name="FAA_TCDS_Number"
                                  value={formData.FAA_TCDS_Number}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form_field">
                              <label>Special Conditions</label>
                              <div className="input_field">
                                <textarea
                                  className="form-control"
                                  placeholder="Enter special conditions"
                                  name="Special_Conditions"
                                  value={formData.Special_Conditions}
                                  onChange={handleInputChange}
                                  rows="3"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Noise Compliance</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter compliance"
                                  name="Noise_Compliance"
                                  value={formData.Noise_Compliance}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-sm-6 col-md-4">
                            <div className="form_field">
                              <label>Emissions Category</label>
                              <div className="input_field">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter category"
                                  name="Emissions_Category"
                                  value={formData.Emissions_Category}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="main_action_blk hstack gap-3 justify-content-start">
                            <Link
                              to="/aircraft"
                              className="bg_primary_outline_btn rounded-pill"
                            >
                              Cancel
                            </Link>
                            <button
                              type="submit"
                              className="primary-btn rounded-pill"
                            >
                              Update
                            </button>
                            {errors.submit && (
                              <span className="error">{errors.submit}</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
